/*
 * Módulo de frontend: páginas "Servicios" (administración de servicios de clientes vía
 * n8n) y su configuración. Standalone (no depende del catálogo).
 */
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import StorageIcon from '@material-ui/icons/Storage';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleIcon from '@material-ui/icons/People';

const clientesPage = PageBlueprint.make({
  name: 'clientes',
  params: {
    path: '/clientes',
    title: 'Clientes',
    icon: <PeopleIcon />,
    loader: () => import('./ClientesPage').then(m => <m.ClientesPage />),
  },
});

const servicesPage = PageBlueprint.make({
  name: 'services',
  params: {
    path: '/servicios',
    title: 'Servicios',
    icon: <StorageIcon />,
    loader: () => import('./ServicesPage').then(m => <m.ServicesPage />),
  },
});

const servicesConfigPage = PageBlueprint.make({
  name: 'services-config',
  params: {
    path: '/servicios-config',
    title: 'Servicios · Configuración',
    icon: <SettingsIcon />,
    loader: () =>
      import('./ServicesConfigPage').then(m => <m.ServicesConfigPage />),
  },
});

export const servicesModule = createFrontendModule({
  pluginId: 'app',
  extensions: [servicesPage, clientesPage, servicesConfigPage],
});
